"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return getSchemasV3;
    }
});
const _schemas = require("./templates/schemas");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
async function getSchemasV3(context, { base, columns, tableName }, _ncMeta = _Noco.default.ncMeta) {
    const swaggerSchemas = (0, _schemas.getModelSchemas)({
        tableName,
        orgs: 'v3',
        baseName: base.title,
        columns
    });
    return swaggerSchemas;
}
